import React from "react";
import styled from "styled-components";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogTrigger,
} from "../../components/ui/alert-dialog";
import { FilterButton } from "../../styles/styles_input_pesquisas";
import Close from "../../assets/kinologyIcons/svg/close.svg";
import Info from "../../assets/kinologyIcons/svg/info.svg";
import { ScrollArea } from "../../components/ui/scrollarea";

const HowWorks: React.FC = () => {


	return (
		<AlertDialog>
			<AlertDialogTrigger style={{ width: "100%" }}>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						color: "#3D4259",
						fontWeight: "600",
						gap: 5,
						marginTop: "1rem",
						marginBottom: "1rem",
						textDecoration: "underline",
						fontSize: "0.8rem",
					}}
				>
					<img src={Info} style={{ width: "1rem" }} /> Entenda como funciona
				</div>
			</AlertDialogTrigger>
			<AlertDialogContent
				className="w-[100%] flex flex-col items-center justify-center p-10"
				style={{ width: "65rem", backgroundColor: "#F1F2F3" }}
			>
				<AlertDialogCancel
					style={{
						position: "absolute",
						top: "1rem",
						right: "1rem",
						border: "none",
						boxShadow: "none",
					}}
				>
					<FilterButton
						onClick={() => {
							return false;
						}}
						src={Close}
					/>
				</AlertDialogCancel>

				<div
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						color: "#3D4259",
						fontWeight: "600",
						gap: 5,
						marginTop: "1rem",
						marginBottom: "1rem",
						textDecoration: "underline",
						fontSize: "1rem",
					}}
				>
					<img src={Info} style={{ width: "1rem" }} /> Entenda como funciona
				</div>

				<ScrollArea className="h-[65vh] w-[100%]" >
					<div
						style={{ color: "#6B7280", fontSize: "0.8rem", marginBottom: 16 }}
					>
						<div
							style={{
								fontWeight: 500,
								color: "#63677A",
								fontSize: "1rem",
								marginBottom: 8,
							}}
						>
							Alterações encontradas
						</div>
						Neste gráfico, utilizamos os relatórios de Assimetria e Relação IQ
						para nos dizer se os pacientes estão{" "}
						<b>Sem Alterações, Alterações Leves, Significativas e Graves.</b>
					</div>
					<div style={{ display: "flex", flexDirection: "row", gap: 32 }}>
						{/* Coluna 1 */}
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: 12,
								flex: 1,
							}}
						>
							<div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
								<span
									style={{
										width: 16,
										height: 16,
										borderRadius: "50%",
										background: "#6EEB83",
										display: "inline-block",
										marginTop: 4,
										minWidth: "16px",
										minHeight: "16px",
										flexShrink: 0
									}}
								/>
								<div>
									<span style={{ fontWeight: 600, color: "#6B7280", fontSize: '0.8rem' }}>
										Sem alterações
									</span>
									<br />
									<span style={{ color: "#6B7280", fontSize: '0.8rem' }}>
										Categoria na qual <b>NÃO houve alterações</b> nos relatórios
										de Assimetria e Relação IQ.
									</span>
								</div>
							</div>
							<div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
								<span
									style={{
										width: 16,
										height: 16,
										borderRadius: "50%",
										background: "#FFD600",
										display: "inline-block",
										marginTop: 4,
										minWidth: "16px",
										minHeight: "16px",
										flexShrink: 0
									}}
								/>
								<div>
									<span style={{ fontWeight: 600, color: "#6B7280", fontSize: '0.8rem' }}>
										Alterações leves
									</span>
									<br />
									<span style={{ color: "#6B7280", fontSize: '0.8rem' }}>
										Alterações <b>consideráveis</b> com a Assimetria com 10-20%
										e/ou Relação IQ entre 40-50% ou 70-80%.
									</span>
								</div>
							</div>
						</div>
						{/* Coluna 2 */}
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: 12,
								flex: 1,
							}}
						>
							<div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
								<span
									style={{
										width: 16,
										height: 16,
										borderRadius: "50%",
										background: "#FFA800",
										display: "inline-block",
										marginTop: 4,
										minWidth: "16px",
										minHeight: "16px",
										flexShrink: 0
									}}
								/>
								<div>
									<span style={{ fontWeight: 600, color: "#6B7280", fontSize: '0.8rem' }}>
										Alterações significativas
									</span>
									<br />
									<span style={{ color: "#6B7280", fontSize: '0.8rem' }}>
										Alterações <b>expressivas</b> com a Assimetria entre 20-35%
										e/ou Relação IQ entre 30-40% ou 80-90%.
									</span>
								</div>
							</div>
							<div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
								<span
									style={{
										width: 16,
										height: 16,
										borderRadius: "50%",
										background: "#D7263D",
										display: "inline-block",
										marginTop: 4,
										minWidth: "16px",
										minHeight: "16px",
										flexShrink: 0
									}}
								/>
								<div>
									<span style={{ fontWeight: 600, color: "#6B7280", fontSize: '0.8rem' }}>
										Alterações graves
									</span>
									<br />
									<span style={{ color: "#6B7280", fontSize: '0.8rem' }}>
										Alterações <b>altamente expressivas</b>, com a Assimetria
										acima de 35% e/ou Relação IQ abaixo de 30% ou acima de 90%.
									</span>
								</div>
							</div>
						</div>
					</div>
					<div
						style={{ color: "#6B7280", fontSize: "0.8rem", marginBottom: 16 }}
					>
						<div
							style={{
								fontWeight: 500,
								color: "#63677A",
								fontSize: "1rem",
								marginBottom: 8,
								marginTop: 30
							}}
						>
							Indicadores Contralaterais
						</div>
						Neste gráfico, consideramos o resultado de maior assimetria do relatório e registramos seu nível de
						<b> risco de lesão é Alto, Médio ou Baixo</b>

						<div
							style={{
								fontWeight: 500,
								color: "#63677A",
								fontSize: "1rem",
								marginBottom: 8,
								marginTop: 30
							}}
						>
							Indicadores Antagônicos
						</div>
						Consideramos o resultado de maior desequilíbrio e registramos se
						<b> há chance de lesão ou não.</b>

						<div
							style={{
								fontWeight: 500,
								color: "#63677A",
								fontSize: "1rem",
								marginBottom: 8,
								marginTop: 30
							}}
						>
							Alteração comparado aos valores de referência
						</div>
						Usamos o relatório de Histórico de força e valores de referência para determinar se os valores estão
						<b> Abaixo do esperado, Dentro do esperado ou Sem valor de referência.</b>

						<div
							style={{
								fontWeight: 500,
								color: "#63677A",
								fontSize: "1rem",
								marginBottom: 8,
								marginTop: 30
							}}
						>
							Contagem de risco por protocolo
						</div>
						Usamos o relatório Assimetria e Relação IQ para nos dizer se os pacientes estão
						<b> Sem Alterações, Alterações Leves, Significativas e Graves e fazemos uma relação com os protocolos executados.</b>


						<div
							style={{
								fontWeight: 500,
								color: "#63677A",
								fontSize: "1rem",
								marginBottom: 8,
								marginTop: 30
							}}
						>
							Contagem de risco por cargo
						</div>
						Usamos o relatório Assimetria e Relação IQ para nos dizer se os pacientes estão
						<b> Sem Alterações, Alterações Leves, Significativas e Graves e fazemos uma relação com os cargos registrados.</b>


					</div>
				</ScrollArea>

				<div className="grid w-full gap-2">
					<AlertDialogAction
						style={{
							backgroundColor: "#000E4B",
							color: "#FAFAFA",
						}}
					>
						Entendi
					</AlertDialogAction>
				</div>
			</AlertDialogContent>
		</AlertDialog>
	);
};

export default HowWorks;
